import { Button, UIHeading3, UIText3 } from '@cian/ui-kit';
import * as React from 'react';
import { InputField } from '../InputField';
import { PasswordField } from '../PasswordField';
import { FormFieldGroupLayout } from '../FieldGroupLayout';
import { ContentLayout } from '../ContentLayout';
import { EKeyCode } from '../../types/keyCodes';
import * as styles from './styles.css';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function EmailRegistrationForm(props) {
  var handleSubmit = props.handleSubmit;
  var handlePreventSubmit = React.useCallback(function (e) {
    e.preventDefault();
  }, []);
  var handleSubmitOnEnter = React.useCallback(function (e) {
    if (e.keyCode === EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['title'],
      children: /*#__PURE__*/_jsx(UIHeading3, {
        children: "\u041F\u0440\u0438\u0434\u0443\u043C\u0430\u0439\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C"
      })
    }), /*#__PURE__*/_jsx(ContentLayout, {
      children: /*#__PURE__*/_jsx("form", {
        onSubmit: handlePreventSubmit,
        children: /*#__PURE__*/_jsx(FormFieldGroupLayout, {
          content: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(InputField, {
              "data-name": "EmailIdInput",
              name: "username",
              id: "username",
              autoComplete: "off",
              autoFocus: !props.autoFocusDisabled,
              disabled: props.isSubmitting,
              value: props.login,
              required: true,
              ref: props.loginRef,
              invalid: props.isLoginInvalid,
              errorMessage: props.loginError,
              onKeyDown: handleSubmitOnEnter,
              onChange: props.onLoginChange,
              type: "text",
              placeholder: "Email \u0438\u043B\u0438 id"
            }), /*#__PURE__*/_jsx(PasswordField, {
              name: "password",
              id: "password",
              hidden: false,
              tabIndex: 0,
              placeholder: "\u041F\u0430\u0440\u043E\u043B\u044C",
              autoComplete: 'new-password',
              value: props.password,
              required: true,
              ref: props.passwordRef,
              invalid: props.isPasswordInvalid,
              disabled: props.isSubmitting,
              onChange: props.onPasswordChange,
              onKeyDown: handleSubmitOnEnter,
              errorMessage: props.passwordError,
              passwordShown: props.passwordShown,
              toggleVisibility: props.togglePasswordVisibility
            }), !props.passwordError && /*#__PURE__*/_jsx(UIText3, {
              color: "black_60",
              "data-testid": "addon",
              children: "\u041E\u0442 8 \u0434\u043E 30 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432"
            })]
          }),
          buttons: /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx(Button, {
              "data-name": "ContinueAuthBtn",
              onClick: handleSubmit,
              fullWidth: true,
              children: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C"
            })
          })
        })
      })
    })]
  });
}